module.exports = __webpack_public_path__ + "static/img/demo-calling.6e246990.png";